import { ERegion } from '../../../repositories/valuation-b2b/entities/graph/GraphDataSetSchema';

export function getLabel(region: ERegion): string {
  switch (region) {
    case ERegion.Msk:
      return 'Москва';
    case ERegion.MosObl:
      return 'Московская область';
    case ERegion.Spb:
      return 'Санкт-Петербург';
    case ERegion.LenObl:
      return 'Ленинградская область';
  }
}
